"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputContext = void 0;
const react_1 = require("react");
exports.InputContext = react_1.createContext({});
exports.InputContext.displayName = 'InputContext';
